// extracted by mini-css-extract-plugin
export default {"root":"u2zYSYh1xy"};